import { useCallback, useEffect, useState } from 'react';
import { TextField, Button, Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import JsonEditorPage from './JsonEditorPage';
import { deleteGameFacts, getGameFactsData, getMatchData, updateGameFactData, updateMatch } from '../../api/index.js';
import { useFetch } from '../../api/useFetch.js';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useParams } from 'react-router-dom';

function MatchManagement() {

  const {id : idMatch } = useParams();

  const [searchText, setSearchText] = useState(idMatch);

  const [idMatchToSearch, setIdMatchToSearch] = useState(idMatch)

  const URLgetMatchData = useCallback(() => {

    if(idMatchToSearch){
      return getMatchData(idMatchToSearch)
    }
      
    
    return () => {}

  }, [idMatchToSearch])

  const [matchData, loading] = useFetch(URLgetMatchData)

  useEffect(() => {
    setIdMatchToSearch('')
  }, [matchData])

  const handleSearch = () => {
    setIdMatchToSearch(searchText)
  };

  


  return (
    <Box sx={{display : 'flex', flexDirection : 'column', alignItems : 'center', position : 'relative'}}>
      <Box sx={{display : 'flex', flexDirection : 'row', alignItems : 'center', width : '100%', justifyContent : 'center', mb : 3}}>
        <TextField
          label="Recherche"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Button variant="contained" onClick={handleSearch}>
          Rechercher
        </Button>
      </Box>

      
      <Box sx={{display : 'flex', flexDirection : 'row',position : 'relative', width : '100%', justifyContent : 'space-between'}}>
        <Box sx={{width : '60%'}}>
          {matchData && <JsonEditorPage data={matchData} url={updateMatch} />}
        </Box>
        <Box sx={{width : '40%'}}>
          <SidePanel idMatch={searchText}/>
        </Box>
      </Box>

      
      
    </Box>
  );
}

const SidePanel = ({idMatch}) => {

  const URLgetGameFactsData = useCallback(() => {

    if(idMatch){
      return getGameFactsData(idMatch)
    }

    return () => {}

  }, [idMatch])

  const [gamefactsData, loading] = useFetch(URLgetGameFactsData)

  const deleteAllGameFacts = async () => {
    // Afficher une boîte de dialogue de confirmation
    const isConfirmed = window.confirm('Êtes-vous sûr de vouloir supprimer tous les GameFacts ?');
    // Si l'utilisateur a confirmé, exécuter la fonction de suppression
    if (isConfirmed) {
      
      await deleteGameFacts(idMatch)
    }
    
  }

  return (
    <Box sx={{position : 'relative'}}>
      {idMatch}
      <Accordion disabled={!gamefactsData || !gamefactsData.length}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Faits de jeu </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {gamefactsData && gamefactsData.map(gf => <JsonEditorPage data={gf} url={updateGameFactData} />)}
          
        </AccordionDetails>
      </Accordion>
      <Button sx={{right : '0'}} variant="contained" color='error' onClick={deleteAllGameFacts}>X</Button>
      <Accordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>Articles</Typography>
        </AccordionSummary>
        <AccordionDetails>
        </AccordionDetails>
      </Accordion>
      <Accordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography>Notations</Typography>
        </AccordionSummary>
      </Accordion>
      <Accordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography>Sondages</Typography>
        </AccordionSummary>
      </Accordion>
      <Accordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography>Quizz</Typography>
        </AccordionSummary>
      </Accordion>
    </Box>
  )
}

export default MatchManagement;